class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('a').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    const discountInput = this.querySelector('input[name="discount"]');
    if (localStorage.getItem('storedDiscount') && discountInput){
      discountInput.value = localStorage.getItem('storedDiscount');  
    }
    const updateBtn = this.querySelector('[data-update-coupon]');
    if (updateBtn) {
      updateBtn.addEventListener('click', (event) => {
        const input = this.querySelector('input[name="discount"]');
        this.val = input ? input.value.trim() : '';
        if (this.val) {
          localStorage.setItem('storedDiscount', this.val);
          fetch(`/discount/${encodeURIComponent(this.val)}`)
            .then((response) => response.text())
            .then(() => {
              if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
                Shopify.getCart((cart) => {
                  window.halo.updateSidebarCart(cart);
                });
              } else {
                $.ajax({
                  type: 'GET',
                  url: (window.routes ? window.routes.root : '') + '/cart?view=ajax_side_cart',
                  cache: false,
                  success: function (data) {
                    $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper').html($(data));
                  }
                });
              }
            });
        }
        const activePopup = document.querySelector('.popup-toolDown.show');
        if (activePopup) activePopup.classList.remove('show');
        const activePreview = document.querySelector('.previewCart');
        if (activePreview) activePreview.classList.remove('active-tool');
      });
    }
  }
}

customElements.define('coupon-code', CouponCode);